import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { Col, Row, Button, Input, Label } from "reactstrap";

import { areaApi } from '../../reducers/areaSlice';


const Area = ({ area, defaultColor = '#aaaaaa' }) => {
    const [areaId, setAreaId] = useState(area ? area.id : null)
    const [name, setName] = useState(area ? area.name : "")
    const [color, setColor] = useState(area ? area.color : defaultColor)
    const dispatch = useDispatch()

    useEffect(() => {
        setAreaId(area ? area.id : null)
        setName(area ? area.name : "")
        setColor(area ? area.color : defaultColor)
    }, [area, defaultColor])

    const onSave = () => {
        let data = {
            ...area,
            name: name,
            color: color
        }

        if(areaId) {
            dispatch(areaApi.update({
                id: areaId,
                area: data
            }))
        } else {
            dispatch(areaApi.create({
                area: data
            }))
        }
    }
    
    return (<div className="pt-2">
        <Row className="p-2">
            <Col md="12" className="text-left">
                <h1 style={{fontSize: '2.25rem', marginBottom: '1em'}}>{areaId ? "AREA" : "NUOVA AREA"}</h1>
            </Col>
        </Row>
        <Row className="p-2">
            <Col md="1" className="text-left">
                <Label><b>Colore</b></Label>
                <input
                    style={{height: '36px', width: '36px', border: 0, display: 'block', cursor: 'pointer'}}
                    type="color"
                    value={color}
                    onChange={(event) => { setColor(event.target.value)} }
                />
            </Col>
        {/* </Row>
        <Row className="p-2 mt-2"> */}
            <Col md="11" className="text-left">
                <Label for="name"><b>Nome</b></Label>
                <Input id="name" type="text" style={{maxWidth: '400px'}} value={name} onChange={(event) => setName(event.target.value)}/>
            </Col>
        </Row>
        <Row className="p-2 mt-2">
            <Col md="12" className="text-left">                    
                <Button id="new_pos_btn" color="primary" style={{whiteSpace: "nowrap"}} onClick={() => { onSave() }} disabled={name === ""}>
                    <span className="fas fa-check"></span> {areaId ? "SALVA AREA" : "CREA AREA"}
                </Button>
            </Col>
        </Row>
    </div>)
}

export default Area;